import script from "./lBarUpperMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./lBarUpperMenu.vue?vue&type=script&setup=true&lang=ts"

import "./lBarUpperMenu.vue?vue&type=style&index=0&id=070a02a6&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070a02a6"]])

export default __exports__